<template>
    <div>
        <MaterialReservationDialog
            :is-open="materialReservationDialog"
            :material-reservation="currentMaterialReservation"
            @on-close="closeMaterialReservationDialog"
        />
        <transition name="page">
            <v-container class="pa-5" fluid>
                <page-title>Rezerwacje materiałów</page-title>
                <v-row align="center">
                    <v-col cols="12" sm="12">
                        <v-container fluid class="pa-0">
                            <v-row justify="end" dense>
                                <v-col cols="6" md="4" lg="3">
                                    <v-text-field
                                        v-model="filters.reservationItemNumber"
                                        append-icon="mdi-magnify"
                                        label="Numer zamówienia / zlecenia..."
                                        single-line
                                        clearable
                                        hide-details
                                        solo
                                        @keyup.enter="changeFilter"
                                        @click:append="changeFilter"
                                        @click:clear="clearFilter('reservationItemNumber')"
                                    />
                                </v-col>
                                <v-col cols="6" md="4" lg="3">
                                    <v-text-field
                                        v-model="filters.materialName"
                                        append-icon="mdi-magnify"
                                        label="Wyszukaj indeks po nazwie"
                                        single-line
                                        clearable
                                        hide-details
                                        solo
                                        @keyup.enter="changeFilter"
                                        @click:append="changeFilter"
                                        @click:clear="clearFilter('materialName')"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-data-table
                                :headers="headers"
                                :items="materialReservations"
                                :loading="materialReservationsLoading"
                                :footer-props="footerProps"
                                :server-items-length="pagination.itemsLength"
                                :mobile-breakpoint="0"
                                name="usersData"
                                @pagination="updatePagination"
                            >
                                <template #item="{item}">
                                    <tr>
                                        <td :class="reservationLabelClass(item.status)">
                                            {{ formatDate(item.createdAt, false) }}
                                        </td>
                                        <td>
                                            {{ item.materialName }}
                                        </td>
                                        <td>
                                            {{ parseEmptyValue(item.ean) }}
                                        </td>
                                        <td>
                                            {{ item.materialIndex }}
                                        </td>
                                        <td>
                                            {{ item.amountWithUOM }}
                                        </td>
                                        <td>
                                            {{ item.xlAmountWithUOM }}
                                        </td>
                                        <td class="text-center">
                                            <div class="d-inline-flex">
                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-btn
                                                            icon
                                                            data-sentry-label="Otwórz"
                                                            v-on="on"
                                                            @click="showMaterialReservationDialog(item)"
                                                        >
                                                            <v-icon color="blue">
                                                                mdi-ballot
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Otwórz</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </transition>
    </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import MaterialReservationDialog from './MaterialReservationDialog.vue'

import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'

import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'MaterialReservationList',
    components: {
        PageTitle,
        MaterialReservationDialog
    },
    mixins: [
        pagination,
        tooltipDelay,
        dateFormatter,
        filters,
        parse
    ],
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('purchases/clearMaterialReservationsFilters')
        next()
    },
    data() {
        return {
            currentMaterialReservation: {},
            materialReservationDialog: false,
            headers: [
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    sortable: false
                },
                {
                    text: 'Nazwa',
                    value: 'materialName',
                    sortable: false
                },
                {
                    text: 'Kod EAN',
                    value: 'ean',
                    sortable: false
                },
                {
                    text: 'Indeks materiałowy',
                    value: 'materialIndex',
                    sortable: false
                },
                {
                    text: 'Ilość',
                    value: 'amountWithUOM',
                    sortable: false
                },
                {
                    text: 'Ilość wysłana do XL',
                    value: 'xlAmountWithUOM',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        materialReservations() {
            return this.$store.state.purchases.materialReservations.materialReservations
        },
        materialReservationsLoading() {
            return this.$store.state.purchases.materialReservations.materialReservationsLoading
        },
        savedFilters() {
            return this.$store.state.purchases.materialReservations.filters
        },
    },
    mounted() {
        this.getMaterialReservations()
    },
    methods: {
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        getMaterialReservations() {
            this.$store.dispatch('purchases/getMaterialReservations', {
                paginate: this.paginate(),
                query: this.filterQuery()
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        reservationLabelClass(value) {
            if (value.id === 10) {
                return 'v-data-table__label v-data-table__label--danger'
            } else if (value.id === 20) {
                return 'v-data-table__label v-data-table__label--success'
            }
        },
        changeFilter() {
            this.$store.dispatch('purchases/setMaterialReservationsFilters', this.filters)
            this.resetPagination()
            this.getMaterialReservations()
        },
        showMaterialReservationDialog(data) {
            this.currentMaterialReservation = data
            this.materialReservationDialog = true
        },
        closeMaterialReservationDialog() {
            setTimeout(() => {
                this.currentMaterialReservation = {}
            }, 500)

            this.materialReservationDialog = false
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getMaterialReservations()
            }
            this.clearPaginationPending()
        }
    }
}
</script>

